import PropTypes from 'prop-types';
import React, { memo } from 'react';
import Modal from '../Modal';

function ConfirmModal({ id, title, message, onConfirm }) {
  return (
    <Modal
      id={id}
      icon="pe-7s-help1"
      iconGradient="bg-green-blue-top"
      title={title}
      contentClass="modal-body-center-h"
      confirmText="Yes"
      cancelText="No"
      confirmHandler={onConfirm}>
      <div>
        <p className="modal-message text-center">{message}</p>
      </div>
    </Modal>
  );
}

ConfirmModal.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default memo(ConfirmModal);
